import { API } from "./api";

export interface Preview {
  id: number;
  hasFile: boolean;
  createdAt: Date;
}

export const convertPreview = (p: API.Preview): Preview => {
  return {
    id: p.id,
    hasFile: p.has_file,
    createdAt: new Date(p.created_at),
  }
}

